import { PackageProviderName } from 'data/ppoints/constants';
import { array, nativeEnum, object, string } from 'zod';

const serviceProviderStepSchema = object({
    // The country the selection below belongs to. Not validated on its own: it is resolved by the
    // selector, never typed, and a missing selection is already reported by `selectedProviders`.
    countryCode: string(),
    selectedProviders: array(nativeEnum(PackageProviderName)).min(1, {
        message: 'WIZARD.SERVICE_PROVIDER_STEP.PROVIDERS_REQUIRED',
    }),
});

export default serviceProviderStepSchema;
